module.exports = __webpack_public_path__ + "static/media/achatdansmaville-logo.ba502958.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/achatdansmaville-logo.jpg
// module id = 64
// module chunks = 0